/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente/entidades/tipoContribuyente';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITipoContribuyente>> => [
    {
        title: formatMessage({ id: 'tipoContribuyente.codigoTipoContribuyente' }),
        field: 'CodigoTipoContribuyente',
    },
    {
        title: formatMessage({ id: 'tipoContribuyente.nombreTipoContribuyente' }),
        field: 'NombreTipoContribuyente',
    },
    {
        title: formatMessage({ id: 'tipoContribuyente.estadoTipoContribuyente' }),
        field: 'EstadoTipoContribuyente',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tipoContribuyente?: ITipoContribuyente) => void,
    cargarTipoContribuyente: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tipoContribuyente: ITipoContribuyente) => void
): Array<Action<ITipoContribuyente>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITipoContribuyente),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarTipoContribuyente,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITipoContribuyente),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITipoContribuyente> = {
    maxBodyHeight: '50vh',
};
